module.exports = __webpack_public_path__ + "img/20190912105513441.ff445e9e.jpg";